export default __webpack_public_path__ + "static/like-fd48898e82c83c67a08acae2f7169266.svg";